// extracted by mini-css-extract-plugin
module.exports = {"multiple":"PreviewGallery_multiple__fcTuk","one":"PreviewGallery_one__37dN_","root":"PreviewGallery_root__3iYZS"};